// Uploaded brand assets (watercolor, earthy)
export const ASSETS = {
  birds: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-impact-19/artifacts/ng3lndnz__10%20Easy%20Watercolor%20Birds%20Kids%20Can%20Paint%20in%20Minutes_.jpeg",
  branch: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-impact-19/artifacts/zkuzxdz1_Procreate%20tree%20trunk%20_%20%D0%91%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.jpeg",
  flowers: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-impact-19/artifacts/pqqsu2ny__%20%284%29.jpeg",
  paper: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-impact-19/artifacts/jsqoy178__%20%282%29.jpeg",
};
